var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDinoDetective(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 146.8 115.8",
    enableBackground: "new 0 0 146.8 115.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.533,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D4E7F4",
    enableBackground: "new    ",
    cx: 72,
    cy: 58,
    r: 57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    d: "M100.1,6.8c27.8,14.8,38.3,49.3,23.6,77.1c-14.8,27.8-49.3,38.3-77.1,23.6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 101.383 9.586)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    id: "b_1_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a_1_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M0.6,0h100v106H0.6V0z"
  }))), /*#__PURE__*/React.createElement("path", {
    mask: "url(#b_1_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005D9A",
    stroke: "#005D9A",
    d: "M19.3,46 c-1.2,0-2.4-0.1-3.6,0c-2.4,0.3-0.9-0.2-3.2,0.4c-1.6,0.4-2.3,2.2-1.9,3.8c0.4,1.5,2,2.4,3.6,2.1c3.1-0.6,2.4-0.4,5.7-1.1L19.3,46 z M40.4,85.8c0.1,1.2-0.3,1.9-1.5,2c-1.1,0.2-2.2,0.4-3.2,0.7c-1.1,0.4-1.7,1.5-1.5,2.6c0.2,1,1,1.9,2.2,1.9c3.2,0,6.5,0.1,9.7,0 c0.5,0,1.3-0.6,1.4-1.1c0.7-3.7,1.4-7.4,2-11L40,78C40.2,80.6,40.3,83.2,40.4,85.8z M96,76.5c-3.8,2.4-8,3.6-12.6,3.4 c-3.7-0.2-6.9-2.5-8.2-6c-1-2.8-1.3-5.8-1.4-8.8c-0.1-3.6-0.1-7.2-0.5-10.7c-0.6-6.3-4.1-10.7-10-13.1c-5.4-2.2-11-2.2-16.7-1.4 c-3.1,0.4-6.3-1.3-7-4.6c-0.6-2.6,0.1-5.1,0.9-7.6c0.9-2.7,1.9-5.5,2.3-8.4c0.7-5.8-1.3-9.9-7.1-11.8C31.4,6.1,27.2,6.8,23.3,9 c-1.5,0.8-3,1.1-4.7,1.1C17,10,15.4,10,13.8,10.2c-6,0.8-8,4.8-7,10.3c0.8,3.9,3.7,5.9,7.2,6.9c2.5,0.7,5.2,0.9,7.9,1.2 c1.2,0.2,1.6,0.6,1.4,1.8c-0.4,2.6-1,5.2-1.2,7.9c-0.2,3.4-0.4,6.9-0.1,10.4c0.2,2.7,1.1,5.3,1.8,7.9c0.4,1.4,0.2,1.8-1.2,2.1 c-0.3,0.1-0.6,0.1-0.8,0.1c-3.2,0.8-6.5,1.5-9.7,2.5C10,61.8,9,63.9,9.6,65.6c0.6,1.8,2.5,2.3,4.7,1.8c4.1-0.9,8.2-1.7,12.2-2.5 c1.1-0.2,1.9,0.2,2.6,1.1c4,5,9,8.7,15.1,10.8c3.5,1.2,7.1,1.9,10.8,2c1.6,0.1,1.8,0.4,2,1.9c0.4,3.4,0.8,6.9,1.3,10.3 c0.3,2,0.2,2.1-1.7,2.7c-0.7,0.2-1.5,0.5-1.9,1.1c-0.4,0.6-0.4,1.6-0.2,2.3c0.3,1.1,1.4,1.4,2.5,1.4c3,0,6.1,0,9.1,0 c1.5,0,1.9-0.5,1.9-1.9c0-3.7,0-7.5,0-11.2c0-0.6,0.3-1.3,0.8-1.7c0.3-0.2,1.2,0,1.6,0.4c5.3,4.5,12.5,3.7,15.5,3.1 c5.5-1,9.6-5.4,11.2-11.4C96.7,76.1,96.4,76.3,96,76.5L96,76.5z M18.6,54.2c-2.4,0.3-1,0-3.4,0.5c-3.6,0.9-6.8-1.2-7.1-4.8 c-0.2-2.3,1.1-4.8,3.4-5.4c2.5-0.7,1.2-0.4,3.8-0.7c1.3-0.2,2.6,0,3.8,0L20.5,31c-1.6-0.2-3.4-0.4-5.1-0.8 c-3.6-0.8-6.9-2.2-9.2-5.3C1.2,18.2,5,8.9,13.3,7.8c1.8-0.2,3.6-0.2,5.4-0.2c1.3,0,2.4-0.2,3.5-0.8c5.7-3.1,11.5-3.4,17.3-0.2 c3.9,2.2,5.6,5.7,5.9,10c0.2,4.1-0.8,8-2.4,11.8c-0.8,2-1.5,4-0.9,6.2c0.5,2.1,2.2,3.2,4.4,2.9c6-0.9,11.9-0.9,17.6,1.4 c6.8,2.8,10.9,7.8,11.7,15.2c0.3,3.2,0.4,6.5,0.5,9.8c0.1,3,0.2,6,1.2,8.9c1,2.9,3.4,4.7,6.5,4.7c5.3,0.1,9.8-1.8,13.7-5.2 c0.7-0.6,1.3-1.6,2.4-0.9c1.1,0.7,0.4,1.7,0.2,2.5c-0.9,3.9-1.8,7.9-4.6,10.8C90.5,90.3,83.4,91,77.4,90c-2.4-0.4-4.6-1.7-6.9-2.8 v2.9c0,2.2,0,4.5,0,6.7c0,2.5-1.4,4.1-3.9,4.1c-3.3,0.1-6.7,0.1-10,0c-2.4-0.1-4.4-1.9-4.7-4.2c-0.3-2.2,1.1-4.3,3.4-5.1 c0.2-0.1,0.4-0.2,0.7-0.3l-1.3-10l-2.9-0.2c-0.3,1.8-0.6,3.5-1,5.3c-0.3,2-0.7,3.9-1,5.9c-0.4,2-1.8,3.2-3.8,3.3 c-3.2,0-6.5,0-9.7,0c-2.3,0-4.3-1.8-4.6-3.9c-0.3-2.5,1.1-4.7,3.5-5.4c0.9-0.2,1.8-0.4,2.8-0.6c-0.1-2.3-0.4-4.6-0.3-6.9 c0-1.7-0.7-2.6-2-3.4c-3.1-1.9-5.7-4.4-8.1-7.2c-0.3-0.3-0.9-0.6-1.4-0.5c-4,0.3-7.9,1.2-11.8,2.4c-2.9,0.9-5.8-0.6-7-3.3 c-1.1-2.6,0.1-6,2.8-7.2c2.8-1.2,5.7-1.8,8.6-2.6c0.7-0.2,1.4-0.3,2.2-0.5C20.7,54,20.7,53.9,18.6,54.2L18.6,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E8F2F9",
    d: "M96,76.5c-3.8,2.4-8,3.6-12.6,3.4c-3.7-0.2-6.9-2.5-8.2-6 c-1-2.8-1.3-5.8-1.4-8.8c-0.1-3.6-0.1-7.2-0.5-10.7c-0.6-6.3-4.1-10.7-10-13.1c-5.4-2.2-11-2.2-16.7-1.4c-3.1,0.4-6.3-1.3-7-4.6 c-0.6-2.6,0.1-5.1,0.9-7.6c0.9-2.7,1.9-5.5,2.3-8.4c0.7-5.8-1.3-9.9-7.1-11.8C31.4,6.1,27.2,6.8,23.3,9c-1.5,0.8-3,1.1-4.7,1.1 C17,10,15.4,10,13.8,10.2c-6,0.8-8,4.8-7,10.3c0.8,3.9,3.7,5.9,7.2,6.9c2.5,0.7,5.2,0.9,7.9,1.2c1.2,0.2,1.6,0.6,1.4,1.8 c-0.4,2.6-1,5.2-1.2,7.9c-0.2,3.4-0.4,6.9-0.1,10.4c0.2,2.7,1.1,5.3,1.8,7.9c0.4,1.4,0.2,1.8-1.2,2.1c-0.3,0.1-0.6,0.1-0.8,0.1 c-3.2,0.8-6.5,1.5-9.7,2.5C10,61.8,9,63.9,9.6,65.6c0.6,1.8,2.5,2.3,4.7,1.8c4.1-0.9,8.2-1.7,12.2-2.5c1.1-0.2,1.9,0.2,2.6,1.1 c4,5,9,8.7,15.1,10.8c3.5,1.2,7.1,1.9,10.8,2c1.6,0.1,1.8,0.4,2,1.9c0.4,3.4,0.8,6.9,1.3,10.3c0.3,2,0.2,2.1-1.7,2.7 c-0.7,0.2-1.5,0.5-1.9,1.1c-0.4,0.6-0.4,1.6-0.2,2.3c0.3,1.1,1.4,1.4,2.5,1.4c3,0,6.1,0,9.1,0c1.5,0,1.9-0.5,1.9-1.9 c0-3.7,0-7.5,0-11.2c0-0.6,0.3-1.3,0.8-1.7c0.3-0.2,1.2,0,1.6,0.4c5.3,4.5,12.5,3.7,15.5,3.1c5.5-1,9.6-5.4,11.2-11.4 C96.7,76.1,96.4,76.3,96,76.5L96,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E8F2F9",
    d: "M40.4,85.8c0.1,1.2-0.3,1.9-1.5,2c-1.1,0.2-2.2,0.4-3.2,0.7 c-1.1,0.4-1.7,1.5-1.5,2.6c0.2,1,1,1.9,2.2,1.9c3.2,0,6.5,0.1,9.7,0c0.5,0,1.3-0.6,1.4-1.1c0.7-3.7,1.4-7.4,2-11L40,78 C40.2,80.6,40.3,83.2,40.4,85.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005D9A",
    d: "M71.4,22.6c-3.1,0-6,2.2-6.1,4.6c0,0.7,0.2,1.3,1.2,1.4 c0.9,0.1,1.3-0.5,1.4-1.2c0.3-1.6,1.5-2.6,3.3-2.7c1.8,0,3.1,1,3.4,2.7c0.1,0.7,0.5,1.2,1.5,1.2c1-0.1,1.2-0.7,1.2-1.4 C77.3,24.8,74.5,22.6,71.4,22.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    d: "M56.9,0.9c-16.1,4.9-28.7,15.8-36,29.5c-4.1,7.7-7.2,18.3-7.3,26.5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 114.383 46.586)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005D9A",
    d: "M22.5,20.3c0,0-2.1-2.1-4.4-4.3c-0.6,0.9-1.3,1.8-2.1,2.4l4.2,4.1c0.3,0.3,0.7,0.5,1.2,0.5 c0.4,0,0.8-0.2,1.2-0.5c0.3-0.3,0.5-0.7,0.5-1.1C23,21,22.8,20.6,22.5,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005D9A",
    d: "M24.5,22.3c0,0-2.1-2.1-4.4-4.3c-0.6,0.9-1.3,1.8-2.1,2.4l4.2,4.1c0.3,0.3,0.7,0.5,1.2,0.5 c0.4,0,0.8-0.2,1.2-0.5c0.3-0.3,0.5-0.7,0.5-1.1C25,23,24.8,22.6,24.5,22.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E8F2F9",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005D9A",
    d: "M18,9.1c0-5-4-9-8.9-9.1S0,4,0,8.9s4,9,8.9,9.1c1.9,0,3.7-0.5,5.2-1.6C16.5,14.7,18,12,18,9.1z M15,9 c0,1.6-0.6,3.1-1.7,4.2C12.1,14.3,10.6,15,9,15c-3.4-0.1-6-2.7-6-6c0-3.3,2.6-5.9,6-6c1.6,0,3.1,0.7,4.3,1.8C14.4,5.9,15,7.4,15,9 L15,9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinoDetective);
export default __webpack_public_path__ + "static/media/dino-detective.aa229a11.svg";
export { ForwardRef as ReactComponent };